import type { ReactNode } from 'react'

/*
  KpiStrip — franja compacta de KPIs sobre una tabla. Los KPIs de módulo son
  contexto, no el contenido: van en tarjetas chicas de una línea para que la
  tabla siga siendo lo primero que se ve.

  Uso:
    <KpiStrip>
      <KpiRow moneda="PEN">
        <StatCard label="Vencido" value={…} tone="danger" />
      </KpiRow>
    </KpiStrip>

  Envuelve `.kpi-strip` / `.kpi-row` / `.kpi-row__cur` de index.css.
*/
export function KpiStrip({ children }: { children: ReactNode }) {
  return <div className="kpi-strip">{children}</div>
}

interface KpiRowProps {
  children: ReactNode
  /** Chip de moneda a la izquierda (PEN / USD). Omitirlo deja la fila sin chip. */
  moneda?: string
}

export function KpiRow({ children, moneda }: KpiRowProps) {
  return (
    <div className="kpi-row">
      {moneda && <span className="kpi-row__cur">{moneda}</span>}
      {children}
    </div>
  )
}
